function DrawGallery(){

    this.build();

}

DrawGallery.prototype.build = function(){

    let that = this;

    const gelleryItems = document.querySelectorAll(".draw-link-gallery");
    gelleryItems.forEach(item => {
        item.addEventListener("click", that.constructGallery.bind(this));
    });

};

DrawGallery.prototype.constructGallery = function(e){

    let that = this;
    this.target = e.currentTarget;
    this.images = $(e.currentTarget).find(".draw-images-gallery");
    this.imagesLength = this.images.length;
    this.imagesLoaded = 0;

    gallery.middleTop = false;
    gallery.middleBottom = false;
    gallery.arrows = (this.imagesLength > 1) ? true : false;
    gallery.construct();

    $(window).on('overlayDone', function() {
        that.loadImage(that.images[that.imagesLoaded]);
    });

};

DrawGallery.prototype.loadImage = function(image){

    let that = this;

    let image_container = $('<div class="draw_image"></div>');
    gallery.containerMiddleCenter.append( image_container );
    image_container.attr('data-pos', that.imagesLoaded );

    let src = $(image).data('draw-images-gallery');

    let imageHtml = "<img src='"+ src +"'>";
    let img = $(imageHtml);

    img.on('load', function(){
        image_container.append( img );
        if( that.imagesLoaded < that.imagesLength - 1 ){
            that.imagesLoaded++;
            that.loadImage( that.images[ that.imagesLoaded ]);
        }else{
            that.initGallery();
        }
    }).attr("src", src);

};

DrawGallery.prototype.initGallery = function(){

    let that = this;
    gallery.initAnimation();
    $(window).on('initDone', function(){
        that.orderItem();
        that.initNavigation();
    });

};

DrawGallery.prototype.orderItem = function(){

    let that = this;

    $('.draw_image').each(function( index ) {

        let degree = that.randomDegree();
        if( index === that.imagesLength - 1 )
            degree = 0;

        gsap.fromTo( this, 0.4, {
            x: '-150%',
            opacity: 0
        },{
            x: '-50%',
            rotation: degree,
            opacity: ( ( 100 / that.imagesLength * 0.01 ) * ( index + 1 ) ),
            delay: 0.1 * index
        });

    });

};

DrawGallery.prototype.initNavigation = function(){

    let that = this;

    if( that.imagesLength > 1 ) {

        gallery.navigationPrev.on('click', function(){
            if (!that.isSwipe)
                that.prevSlide();
        });

        gallery.navigationNext.on('click', function(){
            if (!that.isSwipe)
                that.nextSlide();
        });

    }

    gallery.close.on('click', function(){
        that.deleteGallery();
    });

};

DrawGallery.prototype.deleteGallery = function(){

    let that = this;
    let tl = new gsap.timeline({
        onComplete: function(){
            $('.draw_image').remove();
            gallery.destroy();
        }
    }).pause();
    tl.add('all');

    $('.draw_image').each(function(index){

        let el = $(this);
        tl.to( el, 0.3, {
            x: '150%',
            rotation: 10,
            opacity: 0,
            delay: 0.1 * index
        }, 'all');

        if (index === (that.imagesLength - 1)) {
            tl.play();
        }

    });

};

DrawGallery.prototype.randomDegree = function(){
    this.degMax = 6;
    this.degMin = -10;

    return Math.floor(Math.random() * (this.degMax - this.degMin) ) + this.degMin;
};

DrawGallery.prototype.nextSlide = function(){

    let that = this;
    let current = $('.draw_image[data-pos="' + ( that.imagesLength - 1 ) + '"]');
    let others = $('.draw_image[data-pos!="' + ( that.imagesLength - 1 ) + '"]');

    this.isSwipe = true;

    let tl = new gsap.timeline({
        onComplete: function(){
            that.isSwipe = false;
        }
    });

    tl.add('start');
    tl.to( current, 0.5, {
        x: '150%',
        rotation: 10,
        opacity: ( ( 100 / that.imagesLength * 0.01 ) ),
        onComplete: function(){
            current.css('z-index', 0);
        }
    }, 'start');

    tl.to( current, 0.5, {
        x: '-50%',
        opacity: 100 / that.imagesLength * 0.01,
        rotation : that.randomDegree(),
        onComplete: function(){
            current.attr('data-pos', 0);
        }
    });

    others.each(function(index){

        let el = $(this);
        let newPos = parseInt( el.attr('data-pos') ) + 1;
        let degree = that.randomDegree();
        if( newPos === 2 )
            degree = 0;

        tl.to( el, 0.5, {
            x: '-50%',
            zIndex: newPos,
            rotation: degree,
            opacity: ( ( 100 / that.imagesLength * 0.01 ) * ( newPos + 1 ) ),
            onComplete: function(){
                el.attr( 'data-pos', newPos );
            }
        }, 'start');
    });

};

DrawGallery.prototype.prevSlide = function(){

    let that = this;
    let current = $('.draw_image[data-pos="0"]');
    let others = $('.draw_image[data-pos!="0"]');

    this.isSwipe = true;

    let tl = new gsap.timeline({
        onComplete: function(){
            that.isSwipe = false;
        }
    });

    tl.to( current, 0.5, {
        x: '-150%',
        zIndex: that.imagesLength,
        onComplete: function(){
            current.css('z-index', that.imagesLength - 1);
        }
    });

    tl.add('start');
    tl.to( current, 0.5, {
        x: '-50%',
        opacity: 1,
        rotation : 0,
        onComplete: function(){
            current.attr('data-pos', 2);
        }
    }, 'start');

    others.each(function(index){
        let el = $(this);

        tl.to( el, 0.5, {
            x: '-50%',
            zIndex: parseInt( el.attr('data-pos') ) - 1,
            rotation: that.randomDegree(),
            opacity: ( ( 100 / that.imagesLength * 0.01 ) * ( parseInt( el.attr('data-pos') ) - 1 + 1 ) ),
            onComplete: function(){
                el.attr( 'data-pos', parseInt( el.attr('data-pos') ) - 1 );
            }
        }, 'start');
    });

};
